<template>
  <div class="canvas-container">
    <img
      v-if="canvasImage"
      class="canvas-image"
      :src="canvasImage"
      style="
        max-width: 100%;
        height: auto;
        image-rendering: crisp-edges;
        image-rendering: optimize-contrast;
        image-rendering: crisp-edges;
      "
    />
  </div>
</template>

<script>
import { generateId } from '@utils/id'
import { Canvas } from 'fabric'
export default {
  name: 'QRCodeLabelPrint',
  props: {
    qrAttributes: {
      type: Array,
      default() {
        return []
      },
    },
    width: { type: [String, Number], required: true },
    height: { type: [String, Number], required: true },
  },
  data() {
    this.canvasId = generateId()
    return {
      canvasImage: undefined,
    }
  },
  computed: {
    getWidth() {
      return this.width * 96
    },
    getHeight() {
      return this.height * 96
    },
  },
  watch: {
    width(newValue) {
      this.canvas.setDimensions({ width: newValue * 96 })
      this.canvas.renderAll()
    },
    height(newValue) {
      this.canvas.setDimensions({ height: newValue * 96 })
      this.canvas.renderAll()
    },
  },
  mounted() {
    setTimeout(() => {
      this.canvas = new Canvas(`${this.canvasId}`, {
        width: this.getWidth,
        height: this.getHeight,
        backgroundColor: '#fff',
        border: '1px solid',
        borderColor: '#dee5ed',
        interactive: false,
      })
    })
    setTimeout(() => {
      this.loadCanvasTemplate({
        objects: this.qrAttributes,
        version: '6.5.4',
        background: '#fff',
      })
    })
  },
  methods: {
    loadCanvasTemplate(templateJSON) {
      this.canvas
        .loadFromJSON(templateJSON, () => {
          // Add a small delay for rendering
          setTimeout(() => {
            this.canvas.interactive = false

            // Disable selection and events for all objects
            this.canvas.getObjects().forEach((object) => {
              object.selectable = false // Cannot be selected
              object.evented = false // Ignores events like mouse clicks
            })

            // Reapply custom controls after loading
            this.canvas.renderAll()
            this.canvasImage = this.canvas.toDataURL({
              format: 'png',
              quality: 1.0,
              multiplier: 2, // Higher resolution for crisp QR codes
            })
          }) // 50ms delay
        })
        .then(() => {
          this.$emit('qrcode-image-loaded')
        })
    },
  },
}
</script>
<style>
.canvas-container {
  outline: 1px solid var(--border-color);
}
</style>
